
/** @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replace#making_a_generic_replacer */
export const interpolateUrl = (string: string, values: Record<string, any>) => string.replace(/{(.*?)}/g, (_, offset) => values[offset]);

export type TApiPayload<PATH = undefined, QUERY = undefined, BODY_PARAMS = undefined> = {}
  & (PATH extends undefined
      ? { path?: never }
      : { path: PATH }
    )
  & (QUERY extends undefined
      ? { query?: never }
      : { query: QUERY }
    )
  & (BODY_PARAMS extends undefined
      ? { bodyParams?: never }
      : { bodyParams: BODY_PARAMS }
    )
